// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';

interface Props {
  id: string;
  formValues: any;
  onReset: () => void;
  onRecalibrate: () => void;
}

export default class ButtonsForm extends React.Component<Props> {
  public static defaultProps: Partial<Props> = {
    id: '',
    onRecalibrate: () => { /* pass */ },
  }

  public constructor(props: Props) {
    super(props);
    this.state = {};
  }

  public render(): JSX.Element {
    return (
      <fieldset id={this.props.id}>
        <footer>
          <div className="text-right">
            <label>
              <i>This field is required (*)</i>
            </label>
          </div>
          <div className="text-right">
            {this.props.formValues.loading && (
              <img className="loading-wdna" alt="loading" src="assets/img/loading-wdna.gif" />
            )}

            <button type="submit" className="btn btn-primary">
              Save
            </button>
            &nbsp;&nbsp;
            <button type="button" onClick={this.props.onReset} className="btn btn-primary">
              Reset
            </button>
          </div>
        </footer>
      </fieldset>
    );
  }
}
